<h3>Editing Orientation video</h3>

<mat-form-field class="example-full-width" appearance="fill" style="width:40%">
    <mat-label>Tittle</mat-label>
    <input type="text" matInput [formControl]="tittleFormControl" placeholder="Ex. Introduction">
    <mat-hint>Tittle length should be 3 to 60</mat-hint>
    <mat-error *ngIf="tittleFormControl.hasError('required')">
        Tittle is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<br>
<br>
<mat-form-field class="example-full-width" appearance="fill" style="width:40%">
    <mat-label>Category</mat-label>
    <input type="text" matInput [formControl]="categoryFormControl" placeholder="Ex. Office of Dean">
    <mat-hint>Category length should be 5 to 30</mat-hint>
    <mat-error *ngIf="categoryFormControl.hasError('required')">
        Category is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<br>
<br>
<br>
<button mat-stroked-button (click)="save()">Save</button>
<button mat-stroked-button style="margin-left: 80%;" (click)="onNoClick()">Close</button>